module.exports = __webpack_public_path__ + "img/ely_logo.69efb8d1.png";